import React, { useState } from 'react';

const AddDataCount = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    data_type: '',
    total_count: '',
    description: '',
    type: '',
    page: '' // Keep page in the initial state
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({ data_type: '', total_count: '', description: '', type: '', page: '' });
  };

  return (
    <div className="form-container">
      <h2>Add Data Count</h2>
      <form onSubmit={handleSubmit} className="form">
        <input
          name="data_type"
          value={formData.data_type}
          onChange={handleInputChange}
          placeholder="Data Type"
          className="input-field"
          required
        />
        <input
          name="total_count"
          value={formData.total_count}
          onChange={handleInputChange}
          placeholder="Total Count"
          className="input-field"
          required
        />
        <input
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          placeholder="Description"
          className="input-field"
          required
        />
        <select
          name="page"
          value={formData.page}
          onChange={handleInputChange}
          className="input-field"
          required
        >
          <option value="" disabled>Select Page</option>
          <option value="home">Home</option>
          <option value="warrant">Warrant and criminals</option>
          <option value="global-sanctions">Global sanctions</option>
          <option value="pep">pep</option>
        </select>
        <select
          name="type"
          value={formData.type}
          onChange={handleInputChange}
          className="input-field"
          required
        >
          <option value="" disabled>Select Type</option>
          <option value="consolidate">Consolidate</option>
          <option value="pep">PEP</option>
          <option value="warrant">Warrant</option>
        </select>
        <div className="form-actions">
          <button type="submit" className="submit-btn">Add Data Count</button>
          <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default AddDataCount;
